const actions = {
    BACKUP_ATTACHMENTS_REQUEST: 'BACKUP_ATTACHMENTS_REQUEST',
    BACKUP_ATTACHMENTS_SUCCESS: 'BACKUP_ATTACHMENTS_SUCCESS',
    BACKUP_ATTACHMENTS_ERROR: 'BACKUP_ATTACHMENTS_ERROR',

    BACKUP_DATABASE_REQUEST: 'BACKUP_DATABASE_REQUEST',
    BACKUP_DATABASE_SUCCESS: 'BACKUP_DATABASE_SUCCESS',
    BACKUP_DATABASE_ERROR: 'BACKUP_DATABASE_ERROR',

    backupAttachments: request => ({
        type: actions.BACKUP_ATTACHMENTS_REQUEST,
        request,
    }),
    backupDatabase: request => ({
        type: actions.BACKUP_DATABASE_REQUEST,
        request,
    }),
};

export default actions;
